import {get, post, tuluPost,postAES} from "@/api/request"

// 机构信息
export const postDetail = params => post("/v1/organ/zone/info", params)
// 机构图
export const postResult = params => post("/v1/organ/zone/index", params)
// 拍品中心
export const postStatic = params => post("/v1/organ/art/static", params)
// 最新送拍
export const postSend = params => post("/v1/organ/zone/send/art/list", params)
// 拍品中心导航栏
export const postSalesCenter = params => postAES("/v3/auctions/index", params)
// 新闻导航栏
export const postNews = params => post("/v1/organ/zone/news/list", params)
// 征集送拍列表
export const postCollect = params => post("/v1/organ/zone/collect/list", params)
// 关于我们
export const postAbout = params => post("/v1/organ/zone/about/us", params)
// 获取当前年
export const postDate = params => get("/v1/session/years", params)
// 拍卖预展与结果
export const getSession = params => postAES("/v3/session/index", params)

// 拍品送拍
export const getZone = params => post("/v1/organ/zone/send/art", params)
// 查看首页隐藏模块
export const isState = params => post("/v1/organ/zone/admin/set/list", params)
// 路由
export const addRouter = params => post("/v1/organ/zone/name/list", params)